export function getUserDisplayNames(displayNameInfo) {
    const displayNames = [];
    if (displayNameInfo.firstName) {
        displayNames.push(displayNameInfo.firstName);
    }
    if (displayNameInfo.lastName) {
        displayNames.push(displayNameInfo.lastName);
    }
    if (displayNames.length === 0) {
        displayNames.push(displayNameInfo.emailAddress);
    }
    return displayNames;
}
export function getUserInitials(displayNameInfo) {
    const displayNames = getUserDisplayNames(displayNameInfo);
    return displayNames
        .map((name) => name.charAt(0).toLocaleUpperCase())
        .filter((name) => !!name);
}
